module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Air-conditioning-1e1c24372a087ecdf84349cd661eae8c.svg";